<template>
    <div class="mt-4" id="orderTicketsTable">
        <div v-if="haveItems">
            <div class="border-b pb-2 xs:mb-1">
                <div class="md:flex md:justify-between items-center">
                    <div v-if="haveItems">
                        <div class="flex-auto print:hidden">
                            <div class="flex flex-wrap">
                                <div class="text-xs sm:text-sm font-semibold mr-2">Go to:</div>
                                <template v-for="(tableKey, index) in tableOrder" :key="tableKey">
                                    <a @click.prevent="scrollTo(`scrollTo-${index}`)" class="align-middle text-xs sm:text-sm pr-2 font-semibold cursor-pointer" v-if="tables[tableKey].rows.length > 0">
                                        {{ tables[tableKey].title }}
                                    </a>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-for="(tableKey, index) in tableOrder" class="mt-2" :key="tableKey">
                <div v-if="tables[tableKey].rows.length > 0">
                    <div class="flex print:hidden">
                        <button @click="flipCharts(tableKey)" class="items-center text-xs lg:text-sm btn btn-sm text-blue-600 hover:text-blue-400 mb-2 mt-1 sm:mt-3 ml-auto">
                            <span class="mr-1">FlipCharts</span>
                            <i class="fas fa-chart-area"></i>
                        </button>
                    </div>

                    <div class="border-t-2 border-blue-600">
                        <div class="table-header" :id="`scrollTo-${index}`">
                            <strong>{{ tables[tableKey].title }} Order Ticket Generator</strong>

                            <div class="w-full sm:w-auto ml-0 sm:ml-auto mb-2 sm:mb-0 print:hidden">
                                <a :href="getAddLink(tableKey)" class="btn btn-xs btn-blue mr-2"><i class="fas fa-plus"></i>&nbsp;Add {{ tables[tableKey].title }} Ticket</a>
                                <a :href="getEditGroupLink(tableKey)" class="btn btn-xs btn-yellow"><i class="far fa-edit"></i>&nbsp;Edit {{ tables[tableKey].title }} Group</a>
                            </div>
                        </div>

                        <order-tickets-list
                            :ref="tableKey"
                            :init-table-data="tables[tableKey].rows"
                            :buttons="tables[tableKey].columns[1].buttons"
                            :section="tableKey"
                        >
                        </order-tickets-list>

                    </div>
                </div>
            </div>
        </div>
        <alert-box class="mb-3" v-else>
            <template #body>
                No tickets have been added. Please click one of the buttons below to add an order ticket.
            </template>
        </alert-box>

        <div class="flex flex-wrap justify-center pt-3 mt-8">
            <a :href="getAddLink(tableKey)" class="btn btn-sm btn-blue inline-block mx-1 mb-1" v-for="tableKey in tableOrder" :key="tableKey">
                Add {{ tables[tableKey].title }}
            </a>
        </div>

    </div>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import { useFlipcharts } from '../DataTable/mixins/FlipCharts';
import OrderTicketsList from './OrderTickets/OrderTicketsList';

const props = defineProps({
    defaultTables: Object,
});

const { flipcharts } = useFlipcharts();
const { appContext } = getCurrentInstance();

const tables = ref(props.defaultTables);
const haveItems = ref(false);
const tableOrder = ref(['future', 'option', 'forex']);

const offset = computed(() => {
    const thead = document.querySelector('table.table thead');
    return thead.getBoundingClientRect().height * -1;
});

const scrollTo = (element) => {
    const options = {
        offset: offset.value,
        container: document.body,
    };
    appContext.app.config.globalProperties.$scrollTo(`#${element}`, undefined, options);
};

const getAddLink = (section) => window.route('my-folder.order-tickets.add', { section });
const getEditGroupLink = (section) => window.route('my-folder.order-tickets.group', { section });

const flipCharts = (tableKey) => {
    const symbols = tables.value[tableKey].rows.map((row) => row.symbol);
    flipcharts(symbols);
};

onMounted(() => {
    Object.keys(tables.value).forEach((tableName) => {
        const table = tables.value[tableName];
        if (table.rows.length > 0) {
            haveItems.value = true;
        }
    });
});
</script>

<style lang="scss">
#orderTicketsTable {
    .order-tickets-table {
        &.table {
            thead,
            tfoot {
                td, th {
                    @apply px-3 py-2;
                }
            }
            thead {
                tr {
                    @apply border-t;
                    td, th {
                    }
                }
            }
            tbody {
                td, th {
                    @apply px-3
                }
            }

            td, th {
                @apply px-3 text-right;
                &:first-child {
                    @apply text-left;
                }
            }

            .sortable {
                @apply cursor-pointer;
            }
        }
    }
}
</style>
